// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Zs3","col":"styles_col___fxSe","actions":"styles_actions__1ZJEt","conflict":"styles_conflict__XU0nv"};